import { getProductPackItems } from '@/models/core/ProductPack';
import { getPackItemName, getPackItemUsage } from '@/models/core/PackItem';
import { InciList } from '@/models/core/InciList';

import { PRODUCT_NAMES } from '@/constants/treatment';

const ACTIVE = {
  [PRODUCT_NAMES.FACE_SERUM]: ['faceBottle1Actives', 'faceBottle2Actives'],
  [PRODUCT_NAMES.EYE_CONTOUR_SERUM]: ['eyeBottleActives']
};

const INACTIVE = {
  [PRODUCT_NAMES.FACE_SERUM]: ['faceBottle1InactiveIngridients', 'faceBottle2InactiveIngridients'],
  [PRODUCT_NAMES.EYE_CONTOUR_SERUM]: ['eyeBottleInactiveIngridients']
};

const EXCIPIENTS = {
  [PRODUCT_NAMES.FACE_SERUM]: [
    'faceBottle1ExcipientsFromActives',
    'faceBottle2ExcipientsFromActives'
  ],
  [PRODUCT_NAMES.EYE_CONTOUR_SERUM]: ['eyeBottleExcipientsFromActives']
};

const isValidInciValue = value => typeof value === 'string' && value.trim() !== '';

const normalizeInactive = inactivesStr => inactivesStr.split(', ').filter(isValidInciValue);

const getPackItemInciList = (packItem, i, serumInciListDto) => {
  const usage = getPackItemUsage(packItem);
  const productName = getPackItemName(packItem);
  const activeKey = ACTIVE[productName][i];
  const inactiveKey = INACTIVE[productName][i];
  const excipientsKey = EXCIPIENTS[productName][i];

  const active = serumInciListDto[activeKey].filter(isValidInciValue);
  const inactive = normalizeInactive(serumInciListDto[inactiveKey]);
  const excipients = normalizeInactive(serumInciListDto[excipientsKey] || '');

  return InciList(usage, active, inactive, excipients);
};

/**
 * Get inci lists for product pack from incilist dto.
 *
 * @param {ProductPack} productPack
 * @param {Object} serumInciListDto
 * @return {InciList[]}
 */
export const getSerumInciLists = (productPack, serumInciListDto) => {
  const items = getProductPackItems(productPack);

  return items.map((item, i) => getPackItemInciList(item, i, serumInciListDto));
};
